import api from '@/api';

const state = {
  projects: [],
};

const actions = {
  async getList({ commit }) {
    const response = await api.get('ProjectsController/GetProjectList');

    commit('projects', response.data.value);
  },
};

const mutations = {
  projects(state, payload) {
    state.projects = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
